import React from "react";
import "./Container.css";

export const PageSurface = ({
  children,
  className = "",
  style,
  backgroundColor,
  size = "default",
}) => (
  <div
    className={`g-page-surface g-page-surface--${size} ${className}`}
    style={{ backgroundColor, ...style }}
  >
    {children}
  </div>
);

export const PageWrapper = ({
  children,
  className = "",
  style,
  backgroundColor,
  size = "default",
}) => (
  <div
    className={`g-page-wrapper g-page-wrapper--${size} ${className}`}
    style={{ backgroundColor, ...style }}
  >
    {children}
  </div>
);

export const ContentContainer = ({ children, className = "", style }) => (
  <div className={`g-content-container ${className}`} style={style}>
    {children}
  </div>
);

export const UnauthorisedPageSurface = ({
  children,
  className = "",
  style,
  backgroundColor,
}) => (
  <div
    className={`g-unauthorised-page-surface ${className}`}
    style={{ backgroundColor, ...style }}
  >
    {children}
  </div>
);

// -----------------------------------------------

// REVISE EXISTING COMPONENTS:

export const MainContainer = ({ children, className = "", style }) => (
  <div className={`g-layout ${className}`} style={style}>
    {children}
  </div>
);

export const OutterContainer = ({ children, className = "", style }) => (
  <div className={`g-layout__outer ${className}`} style={style}>
    {children}
  </div>
);

export const InnerContainer = ({ children, className = "", style }) => (
  <div className={`g-layout__inner ${className}`} style={style}>
    {children}
  </div>
);

export const MainContent = ({ children, className = "", style }) => (
  <div className={`g-content-container ${className}`} style={style}>
    {children}
  </div>
);
